import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Input } from "reactstrap";
import removeUsersFromTeam from "../apis/removeUsersFromTeam";

function RemoveUserFromTeamModal({
  remove_user_modal,
  set_remove_user_modal,
  currentUser,
  DummyAvatarSvg,
}) {
  return (
    <Modal
      className="invites-teammates-modal remove-teammates-modal"
      centered
      isOpen={!!remove_user_modal}
      toggle={() => set_remove_user_modal(null)}
    >
      <ModalHeader toggle={() => set_remove_user_modal(null)}></ModalHeader>
      <ModalBody>
        <h3>Are you sure you want to remove this teammate?</h3>
        <div className="my-3 user-info">
          {remove_user_modal?.picture ? (
            <img
              src={remove_user_modal?.picture}
              className="profile-pic"
              alt=""
            />
          ) : (
            <DummyAvatarSvg className="avatar" />
          )}
          <p className="name">{remove_user_modal?.name}</p>
        </div>
        <p className="mt-3 mb-5">
          Removing this teammate will remove them from your account. Note: If
          necessary the teammate can rejoin.
        </p>

        <div className="d-flex justify-content-between">
          <button
            className="back-button"
            onClick={() => set_remove_user_modal(null)}
          >
            Back
          </button>
          <button
            className="cancel-btn"
            onClick={async () => {
              await removeUsersFromTeam({
                team_code: currentUser?.team?.id,
                user_id:
                  remove_user_modal?.Username || remove_user_modal?.user_id,
              });
              set_remove_user_modal(null);
            }}
          >
            Yes, Remove
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default RemoveUserFromTeamModal;
